<template lang="pug">
#modal-visualizacao-area
    //- .linha(v-if='area.aprovado')
    //-     b.coluna {{ "Validação:" }}
    //-     .coluna
    //-         chip-component(
    //-             border-color='transparent',
    //-             :background-color='area.aprovado === "APROVADO" ? "var(--primary-light-green)" : "var(--primary-light-red)"', 
    //-             :color='"var(--primary-white)"',
    //-             :label='area.aprovado === "APROVADO" ? "Aprovado" : "Reprovado"',
    //-             border-radius='5px',
    //-             width='150px'
    //-         )

    .linha
        .coluna
            .caracteristicas
                div(v-for='(caracteristica, i) in area', :key='i')
                    .data(v-if="!verificarCampos(i) && caracteristica")
                        .linha
                            b.coluna {{ getLabel(i) }}
                        .linha
                            .coluna(v-if='i === "bioma"') {{ BiomaEnum[caracteristica].nome }}
                            .coluna(v-if='i === "acoesControle"')
                                li.acoes-controle(v-for='acao in acoesControle' v-html='AcoesControle[acao]')
                            .coluna(v-if='i === "tecnicasPlantio"') {{ TecnicasPlantio[caracteristica] }}
                            .coluna(v-if='i === "usoRecenteSolo"') {{ UsoMaisRecenteSolo[caracteristica] }}
                                .linha.imagem-area(v-if='imagensUsoMaisRecenteSolo.length > 0')
                                    img(
                                        v-for='imagem in imagensUsoMaisRecenteSolo',
                                        :src='"data:image/jpeg;base64," + imagem',
                                        style='padding-bottom: 6px; width: 49%'
                                    )
                            .coluna(v-if='i === "metodosRecomposicao"') {{ MetodosRecomposicao[caracteristica] }}
                            .coluna(v-if='showCaracteristica(i, caracteristica)') {{ caracteristica }}
                            .coluna(v-if='caracteristica && i === "dataAprovacao"') {{ caracteristica | data }}
</template>

<script>
import {
    getAreaCaracteristicaLabel,
    AcoesControle,
    TecnicasPlantio,
    MetodosRecomposicao,
    UsoMaisRecenteSolo
} from '@/utils/analise.utils';
import { BiomaEnum } from '@/enums/imovel.enum.js';
import { buscarImagensArea } from '@/services/etapa-prada.service';

export default {

    name: 'ModalVisualizacaoArea',
    props: {
        area: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            getAreaCaracteristicaLabel,
            AcoesControle,
            TecnicasPlantio,
            MetodosRecomposicao,
            UsoMaisRecenteSolo,
            BiomaEnum,
            imagensUsoMaisRecenteSolo: [],
            acoesControle: null
        };
    },

    async mounted() {
        if (this.area?.acoesControle && this.area?.acoesControle !== '') {
            if (this.area?.acoesControle.includes(',')) { 
                this.acoesControle = this.area.acoesControle.split(',');
            } else {
                this.acoesControle = [this.area.acoesControle];
            };
        }

        this.imagensUsoMaisRecenteSolo = await buscarImagensArea(this.area.imagensUsoMaisRecenteSolo);
    },

    methods: {
        getLabel(key) {
            return getAreaCaracteristicaLabel(key);
        },
        verificarCampos(i) {
            const excludedFields = ['id', 'idArea', 'aprovado', 'aprovacao', 'tipo', 'acao', 'sugestaoWebAmbiente', 'validacao', 'justificativa', 'dataAprovacao', 'imagensUsoMaisRecenteSolo', 'documentosSolicitados'];
            return excludedFields.includes(i);
        },
        showCaracteristica(campo, caracteristica) {
            return caracteristica && campo !== "dataAprovacao" &&
                campo !== "acoesControle" && campo !== "bioma" &&
                campo !== "tecnicasPlantio" && campo !== 'usoRecenteSolo' &&
                campo !== "metodosRecomposicao";
        },
    }
}
</script>

<style scoped>
#modal-visualizacao-area {
    width: 100%;
    max-height: 500px;
    word-break: break-word;

    overflow-y: auto;
}

.acoes-controle {
    padding-bottom: 4px;
}

#modal-visualizacao-area::-webkit-scrollbar {
    width: 8px;
}

#modal-visualizacao-area::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

#modal-visualizacao-area::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.imagem-area {
    display: flex;
    justify-content: space-between; 
}
</style>
